import axios, { AxiosError, AxiosInstance } from 'axios';
import humps from 'humps';
import Qs from 'qs';
import { sendError } from 'services/error-webhook';
import { AppViews } from '../endpoints';

const GipsyApi: AxiosInstance = axios.create({
  baseURL: process.env.REACT_APP_GIPSY_URL,
  params: { locale: process.env.REACT_APP_I18N_DEFAULT_LANGUAGE, format: 'json' },
  transformResponse: [
    ...(axios.defaults.transformResponse as []),
    (data) => {
      if (data instanceof Blob) return data;

      return humps.camelizeKeys(data);
    },
  ],
  paramsSerializer(params) {
    return Qs.stringify(humps.decamelizeKeys(params, { split: /(?=[A-Z0-9])/ }), {
      arrayFormat: 'brackets',
    });
  },
});

GipsyApi.interceptors.response.use(
  (response) => response,
  (error: AxiosError) => {
    if (error.response != null && error.response.status === 401) {
      localStorage.removeItem('authData');
      window.location.href = AppViews.AGENCY_LOGIN;
    }
    sendError(error, window.location.href, error.response?.request.responseURL);
    return Promise.reject(error);
  },
);

export default GipsyApi;
